import React from 'react';
import { FiXCircle, FiAlertTriangle, FiCheckCircle, FiInfo, FiX } from 'react-icons/fi';
interface ErrorProps {
  error?: string | null;
  message?: string;
  type: 'error' | 'warning' | 'success' | 'info';
  handler?: () => void;
  icon?: string;
}

const ICONS = {
  error: <FiXCircle />,
  warning: <FiAlertTriangle />,
  success: <FiCheckCircle />,
  info: <FiInfo />,
};

const ErrorHandler: React.FC<ErrorProps> = ({ error, message, type, handler }) => {
  const classVar = 'default-margin-top-bottom isa_' + type;
  return (
    <div
      className={classVar}
      onClick={handler}
      data-cy="error_handler"
      role={type === 'error' ? 'alert' : 'status'}
      title={handler ? 'Click to dismiss' : undefined}
      style={{ position: 'relative' }}
    >
      <i className="icon">{ICONS[type]}</i>
      {error ? error : message}
      {handler && (
        <i className="icon" style={{ position: 'absolute', right: '1.2rem', opacity: 0.6 }} aria-hidden="true">
          <FiX />
        </i>
      )}
    </div>
  );
};

export default ErrorHandler;
